import * as Configuration from '../../../app.constants.js';

AddAccountBusinessChatConfirmationController.$inject = ['$scope', '$state', '$stateParams', '$http', 'company', 'AlertingFactory'];
export function AddAccountBusinessChatConfirmationController($scope, $state, $stateParams, $http, company, AlertingFactory) {

  $scope.backToAppleRegister = backToAppleRegister;
  $scope.goToSiteInfo = goToSiteInfo;

  init();

  function goToSiteInfo() {
    $state.go('auth.alcmeon.fuse.preferences.account', {
      companyId: $stateParams.companyId,
      siteId: $stateParams.createdSiteId
    })
  }

  function backToAppleRegister() {
    window.location.href = 'https://register.apple.com/';
  }

  function init() {
  }
  
}
